"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var Merchant_consts_1 = require("../Merchant.consts");
var BaseRoute = '/merchant';
var ROUTES = {
    GET_MERCHANT: BaseRoute,
    UPDATE_MERCHANT: BaseRoute,
    CLEAN_MERCHANT: "".concat(BaseRoute, "/clean"),
    FETCH_ALL: '/merchants/',
    CREATE_BY_ACCOUNT_MANAGER: "/".concat(BaseRoute, "/create_by_account_manager/"),
    COPY_MERCHANT_SETTINGS_VALIDATE: "/".concat(BaseRoute, "/copy_merchant_settings_validate/"),
    COPY_MERCHANT_SETTINGS: "/".concat(BaseRoute, "/copy_merchant_settings/")
};
var MerchantEntity = /** @class */ (function (_super) {
    __extends(MerchantEntity, _super);
    function MerchantEntity(session) {
        var _this = _super.call(this, {
            session: session,
            entityName: 'merchant',
            routes: []
        }) || this;
        _this.subscribe();
        return _this;
    }
    MerchantEntity.prototype.updateMerchant = function (merchant) {
        this.service.session.update('merchant', merchant);
    };
    MerchantEntity.prototype.subscribe = function () {
        var _this = this;
        this.realTime.on('merchant update', function (message) {
            _this.updateMerchant(message.merchant);
        });
        this.realTime.on('merchant subscription updated', function (message) {
            _this.updateMerchant(message.data);
        });
    };
    MerchantEntity.prototype.getLocal = function () {
        return this.service.session.merchant;
    };
    MerchantEntity.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localMerchant, merchant;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localMerchant = this.getLocal();
                        if (localMerchant) {
                            return [2 /*return*/, localMerchant];
                        }
                        return [4 /*yield*/, this.service.routeGenerator
                                .get(ROUTES.GET_MERCHANT)
                                .setException('Could not read merchant')
                                .invoke()];
                    case 1:
                        merchant = _a.sent();
                        if (!this.service.session.merchant) {
                            this.service.session.merchant = merchant;
                        }
                        else {
                            this.updateMerchant(merchant);
                        }
                        return [2 /*return*/, merchant];
                }
            });
        });
    };
    MerchantEntity.prototype.updateMerchantRequest = function (merchantData) {
        return __awaiter(this, void 0, void 0, function () {
            var merchant;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .put(ROUTES.UPDATE_MERCHANT)
                            .setException('Could not update merchant')
                            .withExtractor(Merchant_consts_1.merchantExtractor)
                            .withPayload(merchantData)
                            .invoke()];
                    case 1:
                        merchant = _a.sent();
                        this.updateMerchant(merchant);
                        return [2 /*return*/, merchant];
                }
            });
        });
    };
    MerchantEntity.prototype.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(ROUTES.FETCH_ALL)
                            .withExtractor(function (response) { return response.merchants; })
                            .setException('Could not read all merchants')
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MerchantEntity.prototype.clean = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var withDrivers;
            return __generator(this, function (_a) {
                withDrivers = options.withDrivers;
                return [2 /*return*/, this.service.routeGenerator
                        .post(ROUTES.CLEAN_MERCHANT)
                        .withExtractor(lodash_1.stubTrue)
                        .setException(withDrivers ? 'Could not clean merchant and drivers' : 'Could not clean merchant')
                        .withPayload({ withDrivers: withDrivers })
                        .invoke()];
            });
        });
    };
    MerchantEntity.prototype.createMerchantByAccountManager = function (newMerchant) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post(ROUTES.CREATE_BY_ACCOUNT_MANAGER)
                        .withExtractor(function (response) { return response.merchant_guid; })
                        .setException('Could not create merchant by account manager')
                        .withPayload(newMerchant)
                        .invoke()];
            });
        });
    };
    MerchantEntity.prototype.validateMerchantSettingsForCopy = function (originMerchantId, destinationMerchantId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post(ROUTES.COPY_MERCHANT_SETTINGS_VALIDATE)
                        .withExtractor(function (response) { return response.data; })
                        .setException('Failed to validate merchant settings')
                        .withPayload({
                        origin_merchant_id: originMerchantId,
                        destination_merchant_id: destinationMerchantId
                    })
                        .invoke()];
            });
        });
    };
    MerchantEntity.prototype.copyMerchantSettings = function (originMerchantId, destinationMerchantId, fields) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post(ROUTES.COPY_MERCHANT_SETTINGS)
                        .withExtractor(lodash_1.stubTrue)
                        .setException('Could not copy merchant settings')
                        .withPayload({
                        fields: fields,
                        copy_data: {
                            origin_merchant_id: originMerchantId,
                            destination_merchant_id: destinationMerchantId
                        }
                    })
                        .invoke()];
            });
        });
    };
    return MerchantEntity;
}(StoreEntity_1.default));
exports.default = MerchantEntity;
//# sourceMappingURL=MerchantEntity.js.map